import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
} from 'react-icons/fa';
import {
  MdLocationOn,
  MdPhone,
  MdEmail,
  MdBusiness,
} from 'react-icons/md';
import { Helmet } from 'react-helmet';
import './ContactUs.css';

const ContactUs = () => {
  return (
    <div className="contact-section" role="main">
      <Helmet>
        <title>
          Plastic Safety Eyes & Noses Manufacturer in India | Pushkar Enterprises Delhi
        </title>

        <meta
          name="description"
          content="Contact Pushkar Enterprises, a leading plastic safety eyes manufacturer in India. Bulk supplier of soft toy eyes, noses & amigurumi accessories. Visit our Delhi office or call for wholesale orders."
        />

        <meta
          name="keywords"
          content="plastic safety eyes manufacturer India contact, soft toy eyes supplier Delhi contact, toy noses manufacturer India, plush toy accessories supplier Delhi, amigurumi eyes bulk India"
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://pushkar-enterprises.web.app/contact" />

        <meta
          property="og:title"
          content="Contact Pushkar Enterprises | Soft Toy Eyes Manufacturer India"
        />
        <meta
          property="og:description"
          content="Get in touch with Pushkar Enterprises for bulk orders of plastic safety eyes, toy noses & accessories."
        />
        <meta property="og:url" content="https://pushkar-enterprises.web.app/contact" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Pushkar Enterprises" />
        <meta
          name="twitter:description"
          content="Bulk supplier of soft toy eyes and plastic toy accessories in India."
        />
      </Helmet>

      <div className="container">
        {/* 🔥 Heading Upgrade */}
        <div className="contact-container" aria-labelledby="contact-heading">
          <div className="section-title">
            <h1 id="contact-heading">
              Contact Plastic Safety Eyes Manufacturer in India
            </h1>

            <p>
              Get in touch with <strong>Pushkar Enterprises</strong>, a trusted
              <strong> soft toy eyes supplier in Delhi</strong> and manufacturer
              of <strong>plastic safety eyes, toy noses, and plush accessories</strong>.
              Contact us for <strong>bulk orders and wholesale inquiries</strong>.
            </p>

            <div className="title-underline" />
          </div>

          <div className="contact-item">
            <div className="icon-circle">
              <MdBusiness size={24} />
            </div>
            <div className="contact-info">
              <strong>Owner</strong>
              <p>Ajay Girotra</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="icon-circle">
              <MdLocationOn size={24} />
            </div>
            <div className="contact-info">
              <strong>Location (Delhi, India):</strong>
              <p>
                <a
                  href="https://maps.app.goo.gl/5aZKgyQJPbwHqJYv6"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#333', textDecoration: 'underline' }}
                >
                  C-232 Tagore Garden Extension, Delhi-110027, India
                </a>
              </p>
            </div>
          </div>

          <div className="contact-item">
            <div className="icon-circle">
              <MdPhone size={24} />
            </div>
            <div className="contact-info">
              <strong>Call for Bulk Orders:</strong>
              <p>+91 7982155490</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="icon-circle">
              <MdEmail size={24} />
            </div>
            <div className="contact-info">
              <strong>Email:</strong>
              <p>pushkarenterprises@myyahoo.com</p>
            </div>
          </div>
        </div>

        {/* 🔥 Social + Trust Section */}
        <div className="social-media-container">
          <div className="section-title">
            <h2>Connect With Us</h2>
            <p>
              Follow us for product updates, new designs, and manufacturing insights.
            </p>
            <div className="title-underline" />
          </div>

          <div className="social-icons">
            <a href="https://www.facebook.com/yourpage" target="_blank" rel="noopener noreferrer">
              <FaFacebookF className="social-icon facebook" />
            </a>
            <a href="https://www.instagram.com/pushkarenterprises_/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="social-icon instagram" />
            </a>
            <a href="https://www.twitter.com/yourhandle" target="_blank" rel="noopener noreferrer">
              <FaTwitter className="social-icon twitter" />
            </a>
            <a href="https://www.linkedin.com/in/ajaygirotra26" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn className="social-icon linkedin" />
            </a>
          </div>

          {/* 🔥 Map (local SEO boost) */}
          <div className="map-container">
            <h3>Visit Our Delhi Office</h3>
            <iframe
              title="Pushkar Enterprises Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.2455267606865!2d77.1110635742238!3d28.652366183182103!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d03736b2aeeff%3A0x901d7647d7b55a46!2sPushkar%20Enterprises%20-%20Soft%20Toy%20Eyes%2C%20Noses%20%26%20Accessories!5e0!3m2!1sen!2sin!4v1753003836917!5m2!1sen!2sin"
              width="350"
              height="200"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;